import { styled } from '@mui/material';
import { SortingSelect } from '../sorting-select/SortingSelect';

export const WrapperStyled = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacings.unit(4 / 4),
  marginBottom: theme.spacings.unit(28 / 4),
}));

export const TitleStyled = styled('p')(({ theme }) => ({
  fontSize: theme.fonts.utility.size(8),
  margin: 0,
}));

export const SortingSelectStyled = styled(({ className, ...props }: any) => {
  return <SortingSelect className={className} {...props}></SortingSelect>;
})(({ theme }) => ({
  width: 'auto',
  borderBottom: '0',
  '& select': {
    fontSize: theme.fonts.utility.size(8),
    lineHeight: theme.fonts.utility.size(10),
  },
  '& svg': {
    top: `${theme.spacings.unit(1)}`,
  },
}));
